export default __webpack_public_path__ + "static/media/photo--sm--pam3.0d942083.jpg";